<input type="file" #file (change)="addFiles(file.files);" />
<div class="area">
	<app-button i18n *ngIf="hideButton" class="save" [skin]="'simple'" (click)="file.value = null; file.click();">Выбрать файл</app-button>
	<span i18n *ngIf="!value">Файл не выбран</span>
	<span *ngIf="value" class="file">{{value.name}} {{sizeToString(value.size)}}</span>
</div>
